import styled from 'styled-components';

import { DropdownItem, DropdownMenuContainer } from 'components/Dropdown';
import { colors, cssBreakpoints, shadows } from 'theme/theme';

export const StyledDropdownItem = styled(DropdownItem)<{
  $mobileOnly?: boolean;
}>`
  min-width: 170px;
  border-bottom: 1px solid ${colors.selectionGrey};

  &:last-child {
    border-bottom-color: transparent;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    ${({ $mobileOnly }) => ($mobileOnly ? 'display: none;' : undefined)}
  }
`;

export const StyledMenuContainer = styled(DropdownMenuContainer)`
  margin-left: 30px;
  box-shadow: ${shadows.highest};
  background-color: white;
  border-radius: 8px;
  border: 1px solid #ebeced;
`;
